// extracted by mini-css-extract-plugin
export default {"row":"StatisticCustomerSheetTable_row__TEKr5"};